import type { AbsoluteViewportRestriction } from "@map/mapiq-map/AbsoluteViewportRestriction";
import { useRequiredContext } from "@lib/utils";

import { HaNContext } from "../shell/HaNContext";
import { type HaNLayoutMode, useHaNLayoutMode } from "../state/layout/useHaNLayoutMode";

// Keeps a node clear of the filter bar, the phone carousel and the wide detail panel
const VIEWPORT_BY_LAYOUT: Record<HaNLayoutMode, AbsoluteViewportRestriction> = {
  mobile: { paddingTopPixels: 80, paddingRightPixels: 0, paddingBottomPixels: 100, paddingLeftPixels: 0 },
  medium: { paddingTopPixels: 80, paddingRightPixels: 0, paddingBottomPixels: 0, paddingLeftPixels: 0 },
  wide: { paddingTopPixels: 80, paddingRightPixels: 0, paddingBottomPixels: 0, paddingLeftPixels: 420 },
};

/**
 * Pans a node into view when it's behind what covers the map, or zooms to it `evenIfInView`. The node must be on the
 * floor the map shows, and nothing moves until that map is built.
 */
export const useFitNodeInView = () => {
  const { mapViewApiRef } = useRequiredContext(HaNContext);
  const layoutMode = useHaNLayoutMode();

  return (nodeId: string, { evenIfInView = false } = {}) => {
    mapViewApiRef.current?.fitBuildingNodes({
      nodeIds: [nodeId],
      viewportRestriction: VIEWPORT_BY_LAYOUT[layoutMode],
      abortIfAlreadyInView: !evenIfInView,
    });
  };
};
